import { cn } from 'cn';
import { Link } from 'react-router';

/** The site's two-row mark in Fraunces; links to the persona home. */
export function Wordmark({ to, tone = 'cream', className }: { to: string; tone?: 'cream' | 'ink'; className?: string }) {
  return (
    <Link
      to={to}
      aria-label="Beam portal home"
      className={cn('font-heading flex shrink-0 flex-col leading-none no-underline', tone === 'cream' ? 'text-beam-cream' : 'text-beam-ink', className)}
    >
      <span className="text-[15px] font-medium tracking-tight">Beam</span>
      <span className={cn('text-[10px] tracking-[0.08em] uppercase', tone === 'cream' ? 'text-beam-on-ink-muted' : 'text-beam-text-muted')}>Medicolegal</span>
    </Link>
  );
}
